import React, {useEffect} from 'react';
import { useDispatch } from "react-redux";
import querystring from 'query-string';
import './Buttons.scss';
import './components/Components.scss';
import {Redirect, Route, Switch} from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from "./actions";
import BlankPage from './components/BlankPage';
import App from './App';
import CVS from './modules/cvs';
import {AccountsManagement, CvsRoutes, ComponentPlayground} from './chunks';
import {AuditComponent, prefetch as modulesPrefetch} from "./modules";
import Modal, { Header, Content } from "ui-components-rollup/dist/Modal";
import classNames from "classnames";
import buttonsStyles from "ui-components/src/button/button.module.scss";

const TimeoutModal = () => {
    const dispatch = useDispatch();
    const renew = () => {
      dispatch({
          type: "AUTH:RENEW-SSO"
      })
    };

    return <Modal closeTrigger={renew}>
        <Header>
            Authentication Renew
        </Header>
        <Content style={{lineHeight: "40px"}}>
            Your login session as expired. Make sure you have internet connectivity. <button className={classNames(buttonsStyles["primary"])} onClick={renew}>Refresh.</button>
        </Content>
    </Modal>;
};

const AppContainer = ({ auth }) => {
    useEffect(() => {
        modulesPrefetch.forEach(view => view.preload());
    }, []);

    const search = querystring.parse(window.location.search);
    if (auth.status === actions.STATUS_PENDING || search.gotoCvoFreeTrialCampaign || search.gotoCvoFreeTrialCampaign2 || search.gotoCloudTieringFreeTrialCampaign || auth.redirecting) {
        return <BlankPage/>;
    }
    return <>
        {auth.renewTimeout && <TimeoutModal/>}
        <Switch>
            <Route path="/components/playground" render={() => <ComponentPlayground/>}/>
            <Route path="/components/account" component={AccountsManagement}/>
            <Route path="/components/cvs/:flavour" render={ () => <CVS/>}/>
            <Route path="/components/cvsVolumes" render={ () => <Redirect to={`/components/volumes/aws${window.location.search}`}/>}/>
            <Route path="/components/cvsCreateVolume" render={ () => <Redirect to={`/components/volumes/aws/create${window.location.search}`}/> }/>
            <Route path="/components/cvsRightPanel" render={ () => <Redirect to={`/components/volumes/aws/right-panel${window.location.search}`}/> }/>
            <Route path="/components/volumes" render={() => <CvsRoutes/>}/>
            <Route path="/components/audit" render={({location}) => {
                const search = querystring.parse(location.search);
                const resources = search.resources ? search.resources.split(",") : null;
                const agents = search.agents ? search.agents.split(",") : null;
                const services = search.services ? search.services.split(",") : null;
                const managementMode = search.managementMode === 'true';
                return <AuditComponent accountId={search.accountId} resources={resources} agents={agents} services={services} managementMode={managementMode}/>
            }}/>
            <Route path="/" render={() => <App/>}/>
        </Switch>
    </>;
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(AppContainer);
